(() => {
  const query = new URLSearchParams(window.location.search);
  const preview = query.get('preview_theme_id');
  if (preview) {
    document.querySelectorAll('a[data-world-link]').forEach((link) => {
      const url = new URL(link.href, window.location.origin);
      if (url.origin === window.location.origin) {
        url.searchParams.set('preview_theme_id', preview);
        link.href = url.toString();
      }
    });
    document.querySelectorAll('form[data-nr-search], form[data-world-form]').forEach((form) => {
      if (form.querySelector('input[name="preview_theme_id"]')) return;
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'preview_theme_id';
      input.value = preview;
      form.append(input);
    });
  }
  const menu = document.querySelector('.nr-menu, .nw-mobile-menu');
  if (menu) {
    menu.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        menu.open = false;
        menu.querySelector('summary').focus();
      }
    });
    document.addEventListener('click', (event) => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  }
  const grid = document.querySelector('[data-nr-grid]');
  const inputs = [...document.querySelectorAll('[data-nr-search-input]')];
  inputs.forEach((input) => { input.value = query.get('q') || ''; });
  if (!grid) return;
  const home = document.querySelector('[data-nr-home]');
  const category = document.querySelector('[data-nr-category]');
  const sort = document.querySelector('[data-nr-sort]');
  const count = document.querySelector('[data-nr-count]');
  const empty = document.querySelector('[data-nr-empty]');
  const clearButtons = [...document.querySelectorAll('[data-nr-clear]')];
  const cards = [...grid.querySelectorAll('[data-nr-product]')];
  const promos = [...document.querySelectorAll('[data-nr-promo]')];
  const normalize = (value) => value.toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/['’]/g, '').trim();
  if (category && [...category.options].some((option) => option.value === query.get('category'))) category.value = query.get('category');
  function applyFilters(updateUrl = true) {
    const term = normalize(inputs[0]?.value || '');
    const terms = term.split(/\s+/).filter(Boolean);
    const chosen = category?.value || 'all';
    let visible = 0;
    cards.forEach((card) => {
      const text = normalize(card.dataset.search || '');
      const matches = terms.every((word) => text.includes(word)) && (chosen === 'all' || card.dataset.world === chosen);
      card.hidden = !matches;
      if (matches) visible += 1;
    });
    const filtered = Boolean(term) || chosen !== 'all';
    if (home) home.dataset.filtered = String(filtered);
    promos.forEach((promo) => { promo.hidden = filtered; });
    clearButtons.forEach((button) => { if (!empty?.contains(button)) button.hidden = !filtered; });
    if (empty) empty.hidden = visible !== 0;
    if (count) count.textContent = `${visible} ${visible === 1 ? count.dataset.singular : count.dataset.plural}`;
    if (updateUrl) {
      const url = new URL(window.location.href);
      const rawTerm = inputs[0]?.value.trim() || '';
      if (rawTerm) url.searchParams.set('q', rawTerm); else url.searchParams.delete('q');
      if (chosen !== 'all') url.searchParams.set('category', chosen); else url.searchParams.delete('category');
      window.history.replaceState(null, '', url);
    }
  }
  inputs.forEach((input) => input.addEventListener('input', () => {
    inputs.forEach((other) => { if (other !== input) other.value = input.value; });
    applyFilters();
  }));
  document.querySelectorAll('form[data-nr-search]').forEach((form) => form.addEventListener('submit', (event) => {
    event.preventDefault();
    applyFilters();
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.getElementById('designs')?.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  }));
  category?.addEventListener('change', () => applyFilters());
  sort?.addEventListener('change', () => {
    const ordered = [...cards].sort((a, b) => sort.value === 'name' ? a.dataset.title.localeCompare(b.dataset.title) : Number(a.dataset.index) - Number(b.dataset.index));
    ordered.forEach((card) => grid.append(card));
  });
  clearButtons.forEach((button) => button.addEventListener('click', () => {
    inputs.forEach((input) => { input.value = ''; });
    if (category) category.value = 'all';
    applyFilters();
    inputs[0]?.focus();
  }));
  applyFilters(false);
})();
